import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import FormSelect from '../../shared/FormSelect.jsx';
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from '../../../utils/apiUtils.js';
import { SLOT_NAMES } from '../../../utils/constants.js';

const step = 5

const removeDuplicateByKey = ({ array, key = 'label' }) => {
    if (!array) return
    return [...new Map(array.map(item => [item[key], item])).values()]
}

const StepFive = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const [searchText, setSearchText] = useState('');
    const template = getValues("template")
    const nonParticipatingPricingNoControl = getValues("nonParticipatingPricingNoControl")

    const { data } = useQuery({
        queryKey: ['getPricing'],
        // queryFn: async () => {

        //     let hasMore;
        //     let searchAfter;
        //     const metadatas = []

        //     do {
        //         let params = {
        //             size: 10,
        //             //bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //             benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //             category: SLOT_NAMES.NON_PAR_PRICING,
        //             searchAfter,
        //             searchText
        //         };

        //         const sanitizedParams = Object.fromEntries(
        //             Object.entries(params).filter(([key, value]) => value)
        //         );

        //         const results = await fetchTemplateRiderComp(sanitizedParams);
        //         const hits = results.hits.hits

        //         hits.forEach(hit => { metadatas.push(hit._source.metadata) })

        //         const total = results.hits.total.value
        //         hasMore = metadatas?.length < total;
        //         searchAfter = hits.at(-1)?.sort
        //     } while (hasMore)

        //     return metadatas
        // },

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.NON_PAR_PRICING,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows,

        enabled: !!template?.additional?.benefitPlanTemplateKey
        // select: (data) => data.map((metadata, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${i} ${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // }))
    })

    const nonParticipatingPricingNoControlOptions =
        removeDuplicateByKey({
            array: data?.map(d => {
                const splittedHccId = d.benefitPlanRiderHccId.split('-')
                return { value: splittedHccId[0], label: splittedHccId[0] }
            })
        })

    // combination of these 2 selection will be one component
    const nonParticipatingPricingTrueOutOfNetworkOptions = data?.filter(metadata => metadata.benefitPlanRiderHccId.split('-')[0] === nonParticipatingPricingNoControl?.value)
        .map(metatdata => {
            const splittedHccId = metatdata.benefitPlanRiderHccId.split('-')
            return {
                value: splittedHccId[1],
                label: splittedHccId[1],
                additional: metatdata
            }
        })

    return (
        <>
            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Default (from HCC config)</p>
            <div className="form-input">
                <label htmlFor={'coverageTierSet'}>Non Participating Pricing - No Control</label>
                <input
                    style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                    type="text"
                    id={"nonParticipatingPricing"}
                    placeholder="search..."
                    disabled={true}
                    // list="items"
                    autoComplete="off"
                    // onFocus={() => setCurrentPage(0)}
                    // onChange={(e) => {
                    //     setSearchValue(e.target.value);
                    //     debouncedChangeHandler(e);
                    // }}
                    value={'250%ERUC90thANESMH180%ALLNC'}
                />
            </div>

            <div className="form-input">
                <label htmlFor={'coverageTierSet'}>Non Participating Pricing - True Out Of Network</label>
                <input
                    style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                    type="text"
                    id={"nonParticipatingPricing"}
                    placeholder="search..."
                    disabled={true}
                    // list="items"
                    autoComplete="off"
                    // onFocus={() => setCurrentPage(0)}
                    // onChange={(e) => {
                    //     setSearchValue(e.target.value);
                    //     debouncedChangeHandler(e);
                    // }}
                    value={'160%Fac140%Prof70thAnesth'}
                />
            </div>

            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '2rem 0rem 0rem 0rem' }}>Overwrite (with Rider)</p>
            <p style={{ padding: '1rem 0rem 1rem 0rem' }}>{template?.label}</p>
            <FormSelect
                label={'Non Participating Pricing - No Control'}
                name={'nonParticipatingPricingNoControl'}
                control={control}
                options={nonParticipatingPricingNoControlOptions}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={({ value }) => {
                    setValue('nonParticipatingPricingTrueOutOfNetwork', null)
                    // setOutOfnetworkOptions(data
                    //     .filter(metadata => metadata.benefitPlanRiderHccId.split('-')[0] === value)
                    //     .map(metatdata => {
                    //         const splittedHccId = metatdata.benefitPlanRiderHccId.split('-')
                    //         return {
                    //             value: splittedHccId[1],
                    //             label: splittedHccId[1],
                    //             additional: metatdata
                    //         }
                    //     })
                    // )
                }}
            />

            {nonParticipatingPricingNoControl?.value && <FormSelect
                label={'Non Participating Pricing - True Out Of Network'}
                name={'nonParticipatingPricingTrueOutOfNetwork'}
                control={control}
                options={nonParticipatingPricingTrueOutOfNetworkOptions}
                errors={errors}
                placeholder="Select..."
            />
            }

            {/* <ReactJson
                style={{ padding: '1rem' }}
                src={{ nonParticipatingPricingNoControl, nonParticipatingPricingTrueOutOfNetworkOptions } || ''}
                name={false}
                collapsed={1}
                collapseStringsAfterLength={150}
                displayDataTypes={false}
                displayObjectSize={false}
                sortKeys={true}
            /> */}
        </>
    )
}

export default StepFive
